import apiempresaweb from '@/services/api-varejoweb';

export default {
  namespaced: true,

  state: {
    list: [],
    coleta: {},
    coletaitens: [],
    filtroStatus: 'Abertas',
    filtroStatusAntigo: null,

    // Dados temporários para persistência ao navegar para câmera
    tempColetaData: null,
    tempColetaItems: [],
    tempMediaFiles: {},
  },

  getters: {
    list: (state) => state.list,
    coleta: (state) => state.coleta,
    tempColetaData: (state) => state.tempColetaData,
    tempColetaItems: (state) => state.tempColetaItems,
    tempMediaFiles: (state) => state.tempMediaFiles,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }] = await Promise.all([
        apiempresaweb.get('grupo', { params: { ...where, ...params } }),
      ]);

      return data;
    },

    // Salvar dados temporários antes de navegar para câmera
    saveTempColetaData({ commit }, { coletaData, coletaItems, mediaFiles }) {
      commit('SET_TEMP_COLETA_DATA', coletaData);
      commit('SET_TEMP_COLETA_ITEMS', coletaItems);
      commit('SET_TEMP_MEDIA_FILES', mediaFiles);
      
      // Também persiste em sessionStorage como backup
      try {
        sessionStorage.setItem('coleta:tempData', JSON.stringify({
          coletaData,
          itemsCount: coletaItems.length,
        }));
      } catch (err) {
        console.log('Erro ao salvar dados temporários em sessionStorage:', err);
      }
    },

    // Restaurar dados temporários quando retorna da câmera
    restoreTempColetaData({ state }) {
      return {
        coletaData: state.tempColetaData,
        coletaItems: state.tempColetaItems,
        mediaFiles: state.tempMediaFiles,
      };
    },

    // Limpar dados temporários após restauração
    clearTempColetaData({ commit }) {
      commit('SET_TEMP_COLETA_DATA', null);
      commit('SET_TEMP_COLETA_ITEMS', []);
      commit('SET_TEMP_MEDIA_FILES', {});
      try {
        sessionStorage.removeItem('coleta:tempData');
      } catch (err) {
        console.log('Erro ao limpar sessionStorage:', err);
      }
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    SET_COLETA(state, coleta) {
      state.coleta = coleta ?? {};
    },
    CLEAR_COLETA(state) {
      state.coleta = {};
    },
    SET_COLETAITENS(state, itens) {
      state.coletaitens = itens ?? [];
    },
    CLEAR_COLETAITENS(state) {
      state.coletaitens = [];
    },
    ADD_COLETAITENS(state, item) {
      state.coletaitens.push(item);
    },
    DEL_COLETAITENS(state, index) {
      state.coletaitens.splice(index, 1);
    },
    SET_FILTRO_STATUS_ANTIGO(state, filtro) {
      state.filtroStatusAntigo = filtro;
    },
    SET_FILTRO_STATUS(state, filtro) {
      state.filtroStatus = filtro ?? 'Abertas';
    },
    // Mutações para dados temporários
    SET_TEMP_COLETA_DATA(state, data) {
      state.tempColetaData = data;
    },
    SET_TEMP_COLETA_ITEMS(state, items) {
      state.tempColetaItems = items ?? [];
    },
    SET_TEMP_MEDIA_FILES(state, files) {
      state.tempMediaFiles = files ?? {};
    },
  },
};
